import { useEffect } from 'react';
import axiosServices from '../utils/axios';
import useAuth from '../hooks/useAuth';
import {BACKEND_URL} from "@/constants/globalConstants";
import router from "@/routes";
import {getSubRoot} from "@/utils/utils";

const AxiosInterceptor = ({ children }) => {
    const { localLogout, isLoggedIn } = useAuth();

    useEffect(() => {
        const interceptor = axiosServices.interceptors.response.use(
            (response) => response,
            async (error) => {
                if (window.location.pathname.includes('login') && error.status && (error.status === 401 || error.status === 403)) {
                    localLogout()
                    router.navigate(`${getSubRoot(window.location.pathname)}/login`, { replace: true });
                }
                return Promise.reject(error);
            }
        );

        return () => {
            axiosServices.interceptors.response.eject(interceptor);
        };
    }, [localLogout]);

    useEffect(() => {
        if (!isLoggedIn) return;

        const verifySession = async () => {
            try {
                await axiosServices.get(`${BACKEND_URL}/user/me`)
            } catch (error) {}
        };

        const intervalId = setInterval(verifySession, import.meta.env.VITE_AUTO_TOKEN_VERIFICATION_INTERVAL || 5 * 60 * 1000);

        return () => clearInterval(intervalId);
    }, [isLoggedIn]);

    return children;
};

export default AxiosInterceptor;